import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { IMember } from "./types"

export function useMembers(config?: UseQueryOptions<IMember[]>) {
  return useQuery<IMember[]>(["operation", "administration", "members"], {
    ...config,
  })
}

export function useMember(
  memberId?: string,
  config?: UseQueryOptions<IMember>
) {
  return useQuery<IMember>(
    ["operation", "administration", "members", memberId],
    {
      ...config,
    }
  )
}
